import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-171" data-mp="3biwp78cfpoea">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-172" data-mp="3bhllt9mwiinp">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-173" data-mp="36jsdob21feks">
          LE SYSTÈME PROFESSIONNEL <span className="text-tech" data-id="element-174" data-mp="31kgz98p58l6d">COMPLET 6 EN 1</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-tech sm:text-lg" data-id="element-175" data-mp="31mtkpvu41do6">
          Ce qui est inclus
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-176" data-mp="2st6x4t023gq2">
          <p className="font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-177" data-mp="2nv59rvvlkv8s">
            🔧 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-178" data-mp="2dumnkugk92np">
            Le système professionnel complet pour diagnostiquer les pannes automobiles avec
            méthode : électronique et OBD-II, moteur, électricité, transmission, freinage et
            trains roulants, méthodes d’atelier, avec fiches de diagnostic, arbres de décision,
            tableaux de contrôle, procédures pas à pas, checklists atelier et cas pratiques.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-2xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-179" data-mp="yxsbbe2k6a5y">
            SYMPTÔME › <span className="text-tech-light" data-id="element-180" data-mp="1ro0yjkbybkre">CODES</span> › MESURES ›{' '}
            <span className="text-tech-light" data-id="element-181" data-mp="1cqi1zvt1839e">HYPOTHÈSE</span> ›{' '}
            <span className="text-tech-light" data-id="element-182" data-mp="1hqcrbux5sksc">VALIDATION</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-183" data-mp="1ccuistm1b9b">
          {modules.map(module => <article key={module.title} className={`rounded-xl border bg-white p-3 shadow-sm sm:p-4 ${module.featured ? 'border-alert ring-2 ring-alert/30 md:col-span-2 md:order-first' : 'border-metal'}`} style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-184" data-mp="6b7omqx12m8q">
              {module.featured && <p className="mb-1.5 w-fit rounded-md bg-alert px-2 py-0.5 font-display text-2xs font-extrabold uppercase tracking-wide text-white sm:text-xs" data-id="element-185" data-mp="1ua0957b6hvfy">
                  ⭐ Le module central du système
                </p>}
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-navy sm:text-base" data-id="element-186" data-mp="1lamy4a7eoyt4">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-187" data-mp="1gbjtgqvc8ulo" />
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-188" data-mp="35onaj09sipks">{module.body}</p>
              <p className="mt-1 font-display text-xs font-bold uppercase text-tech" data-id="element-189" data-mp="35mki69l60kcw">
                {module.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}